import React, { PureComponent } from 'react';
import { InputType, Handler } from 'react-reactive-form';

interface RadioButtonProps {
  children?: any;
  fieldValue: string;
  id: string;
  handler: (inputType?: InputType, value?: string) => Handler;
  onClick?: () => void;
}

export default class RadioButton extends PureComponent<RadioButtonProps> {

  render() {
    return (
      <div className="custom-control custom-radio">
        <input
          className="custom-control-input"
          type="radio"
          id={this.props.id}
          {...this.props.handler('radio', this.props.fieldValue)}
          onClick={this.props.onClick}
        />
        <label className="custom-control-label" htmlFor={this.props.id}>{this.props.children}</label>
      </div>
    );
  }
}
